<template>
  <div :class="cssClasses" :style="style">
    <svg x="0" y="0" width="32" height="44" viewBox="0 0 38 52">
      <path d="M 13 47 v -20 h -10 l 16 -24 l 16 24 h -10 v 20 z" />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'consumption-arrow',
    props: {
      type: {
        type: String,
        required: true,
      },
      angle: {
        type: Number,
        default: 0,
      },
      classes: {
        type: String,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hidden: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      style: function () {
        return `transform: rotate(${this.angle}deg);`
      },
      cssClasses: function () {
        let classes = ['icon', `icon--${this.type}`]
        if (this.classes) {
          classes.push(this.classes)
        }

        if (this.hidden) {
          classes.push('icon--hidden')
        } else if (this.disabled) {
          classes.push('icon--disabled')
        }

        return classes
      },
    },
  }
</script>

<style lang="scss" scoped>
  .icon {
    display: inline-block;
    vertical-align: middle;

    svg {
      fill: currentColor;
      display: block;
      width: 100%;
      height: auto;
    }

    &--disabled {
      opacity: 0.15;
    }

    &--hidden {
      opacity: 0;
    }

    &--positive,
    &--negative {
      transition: all 0.5s ease 0s;
      width: $meter-read-arrow-width-min;

      @media (min-height: 600px) {
        width: $meter-read-arrow-width-sm;
        margin-top: 1vh;
      }

      @media (min-height: 700px) {
        width: $meter-read-arrow-width-md;
      }

      @media (min-height: 900px) and (min-width: $bp-md) {
        width: $meter-read-arrow-width;
      }

      path {
        stroke-width: 2;
        stroke: $meter-read-arrow-stroke-color;
      }
    }

    &--negative {
      path {
        fill: $supplier;
        stroke: darken($supplier, 0%);
      }
    }

    &--positive {
      path {
        fill: $community;
        stroke: darken($community, 0%);
      }
    }
  }
</style>
